import React from 'react';

// Centered confirm dialog (replaces the browser's window.confirm, which appears at the top of the page)
const ConfirmModal = ({ show, title, message, confirmText = 'OK', cancelText = 'Cancel', danger = false, onConfirm, onCancel }) => {
  if (!show) return null;

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0, 0, 0, 0.6)', zIndex: 9999 }}
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded p-4 shadow-lg text-center" style={{ maxWidth: '440px', width: '90%' }}>
        {title && <h5 className="fw-bold mb-3 text-dark">{title}</h5>}
        <p className="mb-4 text-dark" style={{ whiteSpace: 'pre-wrap' }}>{message}</p>
        <div className="d-flex gap-2">
          <button className="btn btn-outline-secondary px-4 py-2 fw-semibold flex-fill" onClick={onCancel}>{cancelText}</button>
          <button className={`btn ${danger ? 'btn-danger' : 'btn-primary-custom'} px-4 py-2 fw-bold flex-fill`} onClick={onConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
